/****************************************************************************
 ** @license
 ** This demo file is part of yFiles for HTML 2.4.0.3.
 ** Copyright (c) 2000-2021 by yWorks GmbH, Vor dem Kreuzberg 28,
 ** 72070 Tuebingen, Germany. All rights reserved.
 **
 ** yFiles demo files exhibit yFiles for HTML functionalities. Any redistribution
 ** of demo files in source code or binary form, with or without
 ** modification, is not permitted.
 **
 ** Owners of a valid software license for a yFiles for HTML version that this
 ** demo is shipped with are allowed to use the demo source code as basis
 ** for their own yFiles for HTML powered applications. Use of such programs is
 ** governed by the rights and conditions as set out in the yFiles for HTML
 ** license agreement.
 **
 ** THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESS OR IMPLIED
 ** WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 ** MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN
 ** NO EVENT SHALL yWorks BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 ** SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 ** TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 ** PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 ** LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 ** NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 ** SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 **
 ***************************************************************************/
// @ts-ignore
import { NodeTypeName } from 'enumerations/nodetype-name'
import { Component } from 'react'
import { AppTypeName } from 'enumerations/apptype-name';


interface ItemElementProps {
  width: number
  height: number
  tag: { name?: string, typeName: string }
}

export default class GroupTemplate extends Component<ItemElementProps> {

  render(): JSX.Element {
    const storageIcon = 'M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z';
    let color = '#666';
    let colorHeader = '#444';
    if (this.props && this.props.tag && this.props.tag && this.props.tag.typeName) {
      const tp = this.props.tag.typeName;
      if (tp === AppTypeName.CrossAccountApp) {
        color = '#909070';
        colorHeader = '#444';
      } else if (tp === AppTypeName.CrossTenantReceivingApp) {
        color = '#605060';
        colorHeader = '#807080';
      } else if (tp === AppTypeName.CrossTenantSendingApp) {
        color = '#606050';
        colorHeader = '#808070';
      } else if (tp === AppTypeName.ExternalApp) {
        color = '#506070';
        colorHeader = '#504050';
      } else if (tp === AppTypeName.ManagedApp) {
        color = '#60A070';
        colorHeader = '#408050';
      }
    }

    return (
      <g>
        <defs>
          <filter id="f3" x="0" y="0" width={this.props.width} height={this.props.height}>
            <feOffset result="offOut" in="SourceAlpha" dx="5" dy="5" />
            <feGaussianBlur result="blurOut" in="offOut" stdDeviation="5" />
            <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
          </filter>
          <filter x="0" y="0" width="1" height="1" id="solid">
            <feFlood floodColor="#333" result="bg" />
            <feMerge>
              <feMergeNode in="bg" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <rect
          style={{ fill: '#DDD', fillOpacity: 0.25 }}
          x={0}
          y={0}
          rx={4}
          ry={4}
          width={this.props.width}
          height={this.props.height}
          filter={`url(#f3)`}
        />
        <rect
          style={{ fill: color, fillOpacity: 0.25 }}
          x={2}
          y={2}
          rx={4}
          ry={4}
          width={this.props.width - 4}
          height={this.props.height - 4}
        />
        <rect
          style={{ fill: '#DDD' }}
          x={2}
          y={40}
          width={this.props.width - 4}
          height={2}
        />
        <rect
          style={{ fill: colorHeader }}
          x={2}
          y={2}
          width={this.props.width - 4}
          height={38}
        />
        <text
          x={this.props.width / 2}
          y={20}
          fontSize={12}
          style={{ fill: '#ffffff', textAnchor: 'middle', dominantBaseline: 'middle' }}
        >
          {this.props && this.props.tag && this.props.tag && this.props.tag.name}
        </text>
        <text
          x={this.props.width / 2}
          y={33}
          fontSize={9}
          style={{ fill: '#ccc', textAnchor: 'middle', dominantBaseline: 'middle' }}
        >
          {this.props && this.props.tag && this.props.tag && this.props.tag.typeName}
        </text>
        {this.props && this.props.tag && this.props.tag && this.props.tag.typeName === AppTypeName.CrossAccountApp &&
          <g fill={'#DDD'} transform="scale(0.75 0.75)
          translate(5, 15)" >
            <path fill={'#DDD'} d={storageIcon} />
          </g>
        }
        {this.props && this.props.tag && this.props.tag && this.props.tag.typeName === AppTypeName.CrossTenantReceivingApp &&
          <g fill={'#DDD'} transform="scale(0.75 0.75)
            translate(5, 15)" >
            <path fill={'#DDD'} d={storageIcon} />
          </g>
        }
        {this.props && this.props.tag && this.props.tag && this.props.tag.typeName === AppTypeName.CrossTenantSendingApp &&
          <g fill={'#DDD'} transform="scale(0.75 0.75)
          translate(5, 15)" >
            <path fill={'#DDD'} d={storageIcon} />
          </g>
        }
        {this.props && this.props.tag && this.props.tag && this.props.tag.typeName === AppTypeName.ExternalApp &&
          <g fill={'#DDD'} transform="scale(0.75 0.75)
          translate(5, 15)" >
            <path fill={'#DDD'} d={storageIcon} />
          </g>
        }
        {this.props && this.props.tag && this.props.tag && this.props.tag.typeName === AppTypeName.ManagedApp &&
          <g fill={'#DDD'} transform="scale(0.75 0.75)
          translate(5, 15)" >
            <path fill={'#DDD'} d={storageIcon} />
          </g>
        }
      </g>
    )
  }
}
